import { hasStaticCare } from "core/model/patients";
import { ONTOLOGIES } from "core/model/utils/ontologies";
import { Auction, GetOntologyType } from "core/types";
import {
  BodyWrapper,
  PatientProfileInfoCard,
  StringValue,
} from "dsl/organisms/PatientProfileDetailsShared/shared";
import {
  getInsuranceLabel,
  getReferralSourceLabel,
} from "dsl/organisms/PatientProfileDetailsShared/utils";
import Translations from "translations/types";

export function AdmissionsOtherInformationCardPrint({
  auction,
  getOntology,
  translations,
}: {
  auction: Auction;
  getOntology: GetOntologyType;
  translations: Translations;
}) {
  const searchReason =
    auction.admissions?.profile?.search_reason_other?.decrypted ??
    (auction.admissions?.profile?.search_reason
      ? getOntology({
          key: auction.admissions?.profile?.search_reason,
          type: ONTOLOGIES.SEARCH_REASON,
        })
      : translations.careproviderApp.recareAdmissionsProfile.unknown);

  return (
    <PatientProfileInfoCard
      title={
        translations.careproviderApp.recareAdmissionsForm.additionalInformation
          .title
      }
    >
      <BodyWrapper>
        <b className="-mr-3 font-bold">{`${translations.careproviderApp.recareAdmissionsProfile.insurance}${translations.general.colon}`}</b>
        <StringValue
          testId="insurance"
          value={getInsuranceLabel(
            getOntology,
            translations,
            auction?.admissions?.profile?.insurance_type,
            auction?.admissions?.profile?.insurance_other?.decrypted,
          )}
        />
      </BodyWrapper>
      <BodyWrapper>
        <b className="-mr-3 font-bold">{`${translations.careproviderApp.recareAdmissionsProfile.reason}${translations.general.colon}`}</b>
        <StringValue testId="search_reason" value={searchReason} />
      </BodyWrapper>
      <BodyWrapper>
        <b className="-mr-3 font-bold">{`${translations.careproviderApp.recareAdmissionsProfile.marketingChannel}${translations.general.colon}`}</b>
        <StringValue
          testId="referral_sources"
          value={getReferralSourceLabel(
            getOntology,
            translations,
            auction?.admissions?.profile?.referral_sources,
            auction.admissions?.profile?.referral_sources_other?.decrypted,
            !!hasStaticCare(auction?.solutions),
          )}
        />
      </BodyWrapper>
    </PatientProfileInfoCard>
  );
}
